export default {
  Su: "invalid_api_key",
  Bu: "blacklisted",
  wu: "no_device_identifier",
  ku: "invalid_json_response",
  Tu: "empty_response",
  __: "sdk_auth_error",
};
